import { render, staticRenderFns } from "./AddToWishlist.vue?vue&type=template&id=49e9229a&scoped=true&"
import script from "./AddToWishlist.vue?vue&type=script&lang=js&"
export * from "./AddToWishlist.vue?vue&type=script&lang=js&"
import style0 from "./AddToWishlist.vue?vue&type=style&index=0&id=49e9229a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e9229a",
  null
  
)

export default component.exports